module.exports = __webpack_public_path__ + "media/images/img-family-2-9f9f264d.jpg";